module.exports = __webpack_public_path__ + "f38eb08778de62628763372262834383.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/megaphone-s.png
// module id = 2680
// module chunks = 0